// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Przeniesiono: ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Czynność "' + p['label'] + '" ukończona',
  accButtonProgressStatus: (p: { label: string }) => 'Czynność "' + p['label'] + '" w toku',
  accColorPalette: () => 'Paleta kolorów',
  accColorSwatch: () => 'Paleta kolorów',
  accCommandKey: () => 'Polecenie',
  accContextMenuLabel: () => 'czynności',
  accControlKey: () => 'Zamknij',
  accPositionAfter: () => 'po',
  accPositionBefore: () => 'przed',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Aby zmienić kolejność, należy nacisnąć i przytrzymać przyciski ' +
    p['keyPressed'] +
    ' i Shift, a następnie użyć przycisków strzałek.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Należy wprowadzić pełną datę, używając formatu podobnego do następującego: ' +
    p['dateExample'] +
    '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Należy wprowadzić miesiąc i rok, używając formatu podobnego do następującego: ' +
    p['dateExample'] +
    '.',
  chart_labelDataLabel: () => 'Etykieta',
  chart_labelGroup: () => 'Grupa',
  chart_labelSeries: () => 'Seria',
  chart_labelValue: () => 'Wartość',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Proszę wybrać wartość.',
  checkbox_helpForCheckbox: () => 'Pomoc dla pola wyboru',
  checkbox_requiredMessageDetail: () => 'Proszę wybrać wartość.',
  checkbox_selected: () => 'Pole wyboru zaznaczone',
  checkbox_unselected: () => 'Pole wyboru niezaznaczone',
  close: () => 'Zamknij',
  collection_apply: () => 'Zastosuj',
  collection_cancel: () => 'Anuluj',
  collection_loaded: () => 'Załadowano',
  collection_loading: () => 'Ładowanie',
  collection_noData: () => 'Brak danych do wyświetlenia.',
  collection_pixels: () => 'piks.',
  collection_resizeColumnDialog: () => 'Zmienianie rozmiaru kolumny',
  collection_resizeColumnMenu: () => 'Zmień rozmiar kolumny...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Proszę podać liczbę z przedziału od ' + p['MIN'] + ' do ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Wybór wszystkich wierszy',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Wybór wiersza "' + p['ROW_NAME'] + '"',
  collection_sortAscendingSubMenu: () => 'Rosnąco',
  collection_sortColumnMenu: () => 'Sortuj kolumnę',
  collection_sortDescendingSubMenu: () => 'Malejąco',
  collection_sortDisabled: () => 'Niesortowalne',
  collection_sortEnabled: () => 'Sortowalne',
  collection_width: () => 'Szerokość',
  colorPicker_label: () => 'Selektor kolorów',
  confirmation: () => 'Potwierdzenie',
  datePicker_currentDate: () => 'Data bieżąca',
  datePicker_goToToday: () => 'Przejdź do dnia dzisiejszego',
  datePicker_label: () => 'Selektor daty',
  datePicker_month: () => 'Miesiąc',
  datePicker_months: () => 'Miesiące',
  datePicker_next: () => 'Następne',
  datePicker_nextDecade: () => 'Następna dekada',
  datePicker_nextMonth: () => 'Następny miesiąc',
  datePicker_prev: () => 'Poprzednie',
  datePicker_prevDecade: () => 'Poprzednia dekada',
  datePicker_prevMonth: () => 'Poprzedni miesiąc',
  datePicker_restricted: () => 'Ograniczone',
  datePicker_selected: () => 'Wybrane',
  datePicker_today: () => 'Dzisiaj',
  datePicker_weekNum: (p: { NUM: string }) => 'Tydzień ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Numer tygodnia',
  datePicker_year: () => 'Rok',
  datePicker_years: () => 'Lata',
  diagram_promotedLink: () => '1 łącze',
  diagram_promotedLinkAriaDesc: () => 'Pośrednie',
  diagram_promotedLinks: (p: { num_links: string }) => 'Łącza: ' + p['num_links'],
  error: () => 'Błąd',
  expandableList_expandCollapseInstructionText: () =>
    'Do rozwijania i zwijania proszę używać klawiszy ze strzałkami',
  expandableList_groupCollapse: () => 'Zwinięte',
  expandableList_groupExpand: () => 'Rozwinięte',
  filePicker_addFiles: () => 'Dodaj pliki',
  filePicker_dropzonePrimaryText: () => 'Przeciąganie i upuszczanie',
  filePicker_dropzoneSecondaryText: () => 'Proszę wybrać plik lub go tutaj przeciągnąć',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Proszę wybrać pliki lub je tutaj przeciągnąć',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nie można wysłać plików typu ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Proszę wysyłać po jednym pliku',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nie można wysłać plików typu ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'nieznany',
  formControl_clear: () => 'Wyczyść',
  formControl_day: () => 'Dzień',
  formControl_empty_segment: () => 'Pusty',
  formControl_helpAvailable: () => 'Pomoc dostępna',
  formControl_hide: () => 'Ukryj',
  formControl_hour: () => 'Godzina',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Osiągnięto limit wynoszący ' +
    ((
      {
        one: new Intl.NumberFormat('pl').format(p['CHARACTER_LIMIT']) + ' znak',
        few: new Intl.NumberFormat('pl').format(p['CHARACTER_LIMIT']) + ' znaki',
        many: new Intl.NumberFormat('pl').format(p['CHARACTER_LIMIT']) + ' znaków'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('pl').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('pl').format(p['CHARACTER_LIMIT']) + ' znaku') +
    '.',
  formControl_loading: () => 'Ładowanie',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Można wprowadzić maksymalnie następującą liczbę znaków: ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Przekroczono maksymalną długość ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Pozostało znaków: ' + p['CHARACTER_COUNT'] + '.',
  formControl_millisecond: () => 'Milisekunda',
  formControl_minute: () => 'Minuta',
  formControl_month: () => 'Miesiąc',
  formControl_readOnly: () => 'Tylko do odczytu',
  formControl_requiredMessageDetail: () => 'Proszę wprowadzić wartość.',
  formControl_second: () => 'Sekunda',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Należy wybrać ' + p['n'] + ' wartości.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Osiągnięto limit wyboru wynoszący ' + p['max'] + '.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Należy wybrać od ' + p['min'] + ' do ' + p['max'] + ' wartości.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Należy wybrać co najmniej ' + p['min'] + ' wartości.',
  formControl_show: () => 'Pokaż',
  formControl_year: () => 'Rok',
  gantt_labelDate: () => 'Data',
  gantt_labelEnd: () => 'Koniec',
  gantt_labelLabel: () => 'Etykieta',
  gantt_labelRow: () => 'Wiersz',
  gantt_labelStart: () => 'Początek',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nie znaleziono zgodnej sekcji.',
  indexer_keyboardInstructionText: () => 'Aby wybrać wartość, proszę nacisnąć klawisz Enter.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Między ' + p['FROM_SECTION'] + ' a ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Aby przełączyć się do trybu gestów, proszę 2x stuknąć i przytrzymać, a następnie - aby dostosować wartość - przeciągnąć w górę lub w dół.',
  info: () => 'Informacja',
  inputColor_selectColor: () => 'Proszę wybrać kolor',
  inputDateMask_date_cleared: () => 'Data wyczyszczenia',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Pusty',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'rrrr',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Należy wprowadzić datę ' + p['max'] + ' lub wcześniejszą.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Należy wprowadzić datę ' + p['min'] + ' lub późniejszą.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Należy wprowadzić dostępną datę.',
  inputDatePicker_instruction: () =>
    'Aby uzyskać dostęp do kalendarza, należy nacisnąć klawisz Tab.',
  inputDatePicker_selectDate: () => 'Proszę wybrać datę',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Należy wprowadzić miesiąc i rok przypadający na ' + p['max'] + ' lub wcześniejszy.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Należy wprowadzić miesiąc i rok przypadający na ' + p['min'] + ' lub późniejszy.',
  inputNumber_converterParseError: () => 'Proszę wprowadzić liczbę.',
  inputNumber_decrease: () => 'Zmniejsz',
  inputNumber_increase: () => 'Zwiększ',
  inputPassword_hidden: () => 'Hasło ukryte',
  inputPassword_hide: () => 'Ukryj hasło',
  inputPassword_show: () => 'Pokaż hasło',
  inputSensitiveText_hidden: () => 'Tekst danych wrażliwych ukryty',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Należy wprowadzić godzinę ' + p['max'] + ' lub wcześniejszą.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Należy wprowadzić godzinę ' + p['min'] + ' lub późniejszą.',
  inputTimeMask_time_cleared: () => 'Czas wyczyszczenia',
  labelNone: () => 'Brak',
  list_msgFetchCompleted: () => 'Załadowano',
  list_msgFetchingData: () => 'Ładowanie',
  list_suggestion: () => 'Sugestia',
  menu_stateLoading: () => 'Ładowanie',
  messageToast_allMessagesClosed: () => 'Wszystkie wyskakujące powiadomienia są zamknięte.',
  message_close: () => 'Zamknij',
  message_confirmation: () => 'Powodzenie',
  message_error: () => 'Błąd',
  message_info: () => 'Informacja',
  message_navigationFromMessagesRegion: () =>
    'Wchodzenie do obszaru komunikatów. Aby przejść, należy nacisnąć klawisz F6.',
  message_navigationToMessagesRegion: () =>
    'W obszarze komunikatów są nowe komunikaty. Aby przejść do nich, należy nacisnąć klawisz F6.',
  message_navigationToTouch: () => 'W obszarze komunikatów są nowe komunikaty.',
  message_warning: () => 'Ostrzeżenie',
  noData_message: () => 'Brak elementów do wyświetlenia',
  overflowItemLabel: () => 'Więcej kart',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Aby zamknąć okno wyskakujące, proszę dwa razy stuknąć.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Wchodzenie do okna wyskakującego. Do przechodzenia między oknem wyskakującym a powiązanym formantem proszę używać klawisza F6.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Okno wyskakujące otwarte. Do przechodzenia między oknem wyskakującym a powiązanym formantem proszę używać klawisza F6.',
  progressIndeterminate: () => 'W toku',
  radioButton_checked: () => 'Przycisk radiowy zaznaczony',
  radioButton_selected: () => 'Przycisk radiowy wybrany',
  radioButton_unchecked: () => 'Przycisk radiowy niezaznaczony',
  radioButton_unselected: () => 'Przycisk radiowy niewybrany',
  radio_helpForRadio: () => 'Pomoc dot. przycisku radiowego',
  radio_requiredMessageDetail: () => 'Proszę wybrać wartość.',
  selectMultiple_apply: () => 'Zastosuj',
  selectMultiple_back: () => 'Wstecz',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Aby wyróżnić wybrane wartości, należy użyć klawiszy ze strzałką w lewo lub w prawo.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Aby usunąć wybraną wartość, proszę nacisnąć klawisz Backspace lub Delete',
  selectMultiple_selectedValues: () => 'Wybrane wartości',
  selectMultiple_showSelectedValues: () => 'Pokaż tylko wybrane wartości.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' wybrane wartości.',
  select_addToList: () => 'Dodaj do listy',
  select_addToListAvailable: () => 'Dodaj do listy (dostępne)',
  select_closeDropdown: () => 'Aby zamknąć, należy nacisnąć klawisz Escape.',
  select_moreSearchOptions: () => 'Więcej opcji wyszukiwania',
  select_moreSearchOptionsAvailable: () => 'Więcej opcji wyszukiwania (dostępne)',
  select_noMatchesFound: () => 'Nie znaleziono zgodnych.',
  select_oneMatchFound: () => 'Znaleziono zgodnych: 1',
  select_requiredMessageDetail: () => 'Proszę wybrać wartość.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Znaleziono zgodnych: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Znaleziono zgodnych: ' + p['TOTAL_SIZE'] + ' lub więcej',
  selectorAll_deselectAll: () => 'Cofnij wybór wszystkich',
  selectorAll_selectAll: () => 'Wybierz wszystkie',
  selector_selected: () => 'Pole wyboru zaznaczone',
  selector_unselected: () => 'Pole wyboru niezaznaczone',
  sheet_close: () => 'Zamknij',
  switch_off: () => 'Wył.',
  switch_on: () => 'Wł.',
  tabBarNavigationList_removeCueText: () => 'Możliwe do usunięcia',
  tabBar_tabContainsErrors: () => 'Zawiera błędy',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Usunięto "' + p['itemKey'] + '"',
  tabbar_labelContextMenu: () => 'zawiera menu kontekstowe',
  tabbar_labelMoveLeft: () => 'Przenieś w lewo',
  tabbar_labelMoveRight: () => 'Przenieś w prawo',
  tabbar_labelRemove: () => 'Usuń',
  timeComponent_tooltipZoomIn: () => 'Powiększ',
  timeComponent_tooltipZoomOut: () => 'Pomniejsz',
  timeConverter_parseError: () => 'Należy wprowadzić godzinę w pełnym formacie.',
  train_current: () => 'Bieżące',
  train_message_type: () => 'Typ wiadomości',
  train_not_visited: () => 'Nieodwiedzone',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Etap ' + p['currentStep'] + ' z ' + p['numberOfSteps'],
  train_visited: () => 'Odwiedzone',
  userAssistance_learnMore: () => 'Dalsze informacje',
  userAssistance_required: () => 'Wymagane',
  vis_clearSelection: () => 'Wyczyść wybór',
  vis_drillable: () => 'Możliwe do drążenia',
  vis_invalidData: () => 'Niepoprawne dane',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' z ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Zaznaczanie obszaru',
  vis_marqueeZoomTooltip: () => 'Powiększanie obszaru',
  vis_noData: () => 'Brak danych do wyświetlenia',
  vis_panTooltip: () => 'Panoramowanie',
  vis_stateCollapsed: () => 'Zwinięte',
  vis_stateExpanded: () => 'Rozwinięte',
  vis_stateLoaded: () => 'Załadowano',
  vis_stateLoading: () => 'Ładowanie',
  vis_stateSelected: () => 'Wybrane',
  vis_stateUnselected: () => 'Niewybrane',
  warn: () => 'Ostrzeżenie'
};
export default bundle;
